import * as e from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var t = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var n = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", h = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", h);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", h), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				let n = Math.min(c * 2 ** (p - 1), s ?? 3e4);
				await f(n);
			}
		}
	}() };
}, r = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, i = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = ({ allowReserved: e, explode: t, name: n, style: a, value: o }) => {
	if (!t) {
		let t = (e ? o : o.map((e) => encodeURIComponent(e))).join(i(a));
		switch (a) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let c = r(a), l = o.map((t) => a === "label" || a === "simple" ? e ? t : encodeURIComponent(t) : s({
		allowReserved: e,
		name: n,
		value: t
	})).join(c);
	return a === "label" || a === "matrix" ? c + l : l;
}, s = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: o }) => {
	if (i instanceof Date) return o ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let c = a(r), l = Object.entries(i).map(([t, i]) => s({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(c);
	return r === "label" || r === "matrix" ? c + l : l;
}, l = /\{[^{}]+\}/g, u = ({ path: e, url: t }) => {
	let n = t, r = t.match(l);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let l = e[i];
		if (l == null) continue;
		if (Array.isArray(l)) {
			n = n.replace(t, o({
				explode: r,
				name: i,
				style: a,
				value: l
			}));
			continue;
		}
		if (typeof l == "object") {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: l,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${s({
				name: i,
				value: l
			})}`);
			continue;
		}
		let u = encodeURIComponent(a === "label" ? `.${l}` : l);
		n = n.replace(t, u);
	}
	return n;
}, d = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = u({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function f(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var p = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, m = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let l = e[i] || t;
		if (Array.isArray(a)) {
			let e = o({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...l.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = c({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...l.object
			});
			e && r.push(e);
		} else {
			let e = s({
				allowReserved: l.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, h = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, g = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, _ = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (g(t, n.name)) continue;
		let e = await p(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, v = (e) => d({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : m(e.querySerializer),
	url: e.url
}), y = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = x(e.headers, t.headers), n;
}, b = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, x = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? b(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, S = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, C = () => ({
	error: new S(),
	request: new S(),
	response: new S()
}), w = m({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), T = { "Content-Type": "application/json" }, E = (e = {}) => ({
	...t,
	headers: T,
	parseAs: "auto",
	querySerializer: w,
	...e
}), D = ((e = {}) => {
	let t = y(E(), e), r = () => ({ ...t }), i = (e) => (t = y(t, e), r()), a = C(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: x(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await _({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: v(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: f(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? h(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let p = d ?? u, m = p;
		for (let e of a.error.fns) e && (m = await e(p, c, i, t));
		if (m ||= {}, t.throwOnError) throw m;
		return t.responseStyle === "data" ? void 0 : {
			error: m,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: r, url: i } = await o(t);
		return n({
			...r,
			body: r.body,
			headers: r.headers,
			method: e,
			onRequest: async (e, t) => {
				let n = new Request(e, t);
				for (let e of a.request.fns) e && (n = await e(n, r));
				return n;
			},
			serializedBody: f(r),
			url: i
		});
	};
	return {
		buildUrl: (e) => v({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: r,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: i,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(E({
	baseUrl: "https://iam.api.myparcel.nl",
	throwOnError: !0
})), O = e.enum(/* @__PURE__ */ "ORDER_MANAGEMENT.LEGACY_ORDER_MANAGEMENT.AUTO_ORDER_IMPORT.BOL_DOT_COM_VVB_SHIPMENTS.CUSTOM_CONTRACTS.DIRECT_PRINTING.DISABLE_LABEL_HEADLINE.EXTENDED_SHIPPING_RULES.NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP.ORDER_INVOICE.ORDER_NOTES.ORDER_PICKLIST.RETURN_LINK_ON_PACKING_SLIP.SAVE_ORDER_SORTING_SETTING.SCAN_MODE.SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK.SHIPMENT_BULK_EDITS.SHIPMENT_DISCOUNT.SHOP_LOGO_ON_PACKING_SLIP.TIER1_ANALYTICS.TIER2_ANALYTICS.TIER3_ANALYTICS.TIER4_ANALYTICS.TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS.UNLIMITED_SHIPMENTS_PER_ORDER_LINE.UNLIMITED_SHIPPING_RULES".split(".")).register(e.globalRegistry, { description: "A feature that is available in the platform." }), k = e.enum(["VASCO"]).register(e.globalRegistry, { description: "The fulfilment platform used." }), A = e.enum([
	"MYPARCEL_BE",
	"MYPARCEL_NL",
	"MYPARCEL_IT"
]).register(e.globalRegistry, { description: "The operating platform identifier." }), j = e.string().regex(/^shop\/.{1,250}$/).register(e.globalRegistry, { description: "A shop principal identifier." }), M = e.string().regex(/^user\/.{1,250}$/).register(e.globalRegistry, { description: "A user principal identifier." }), N = e.union([j, M]), P = e.enum(["SHOP_DEFAULT"]).register(e.globalRegistry, { description: "The specific role assigned to a shop." }), F = e.enum([
	"ADMIN_CS",
	"ADMIN_CS_ADVANCED",
	"ADMIN_FINANCE",
	"ADMIN_IT_SUPPORT",
	"ADMIN_SALES",
	"ADMIN_SUPER",
	"CUSTOMER_ADMIN",
	"CUSTOMER_FINANCIAL",
	"CUSTOMER_FUNCTIONAL_MANAGER",
	"CUSTOMER_MAIN",
	"CUSTOMER_MARKETING",
	"CUSTOMER_SERVICE",
	"CUSTOMER_SUB",
	"CUSTOMER_WAREHOUSE"
]).register(e.globalRegistry, { description: "The specific role assigned to a user." }), I = e.object({
	accountId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the account." }),
	platform: A,
	features: e.array(O).min(1).max(26).optional(),
	fulfilmentPlatforms: e.tuple([k]).optional(),
	impersonator: N.optional()
}), L = I.and(e.object({
	id: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	type: e.enum(["SHOP"]).register(e.globalRegistry, { description: "The principal type." }),
	role: P,
	shopIds: e.tuple([e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." })])
})), R = I.and(e.object({
	id: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the user." }),
	type: e.enum(["USER"]).register(e.globalRegistry, { description: "The principal type." }),
	role: F,
	shopIds: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(500)
})), z = e.union([e.object({ type: e.literal("SHOP") }).and(L), e.object({ type: e.literal("USER") }).and(R)]), B = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
}), V = z, H = e.union([e.enum(/* @__PURE__ */ "ORDER_MANAGEMENT.LEGACY_ORDER_MANAGEMENT.AUTO_ORDER_IMPORT.BOL_DOT_COM_VVB_SHIPMENTS.CUSTOM_CONTRACTS.DIRECT_PRINTING.DISABLE_LABEL_HEADLINE.EXTENDED_SHIPPING_RULES.NESTED_SHIPMENT_LABEL_ON_PACKING_SLIP.ORDER_INVOICE.ORDER_NOTES.ORDER_PICKLIST.RETURN_LINK_ON_PACKING_SLIP.SAVE_ORDER_SORTING_SETTING.SCAN_MODE.SHIPMENT_BULK_CREATE_FROM_ADDRESS_BOOK.SHIPMENT_BULK_EDITS.SHIPMENT_DISCOUNT.SHOP_LOGO_ON_PACKING_SLIP.TIER1_ANALYTICS.TIER2_ANALYTICS.TIER3_ANALYTICS.TIER4_ANALYTICS.TRACK_TRACE_EMAIL_SECONDARY_RECIPIENTS.UNLIMITED_SHIPMENTS_PER_ORDER_LINE.UNLIMITED_SHIPPING_RULES".split(".")), e.string()]).register(e.globalRegistry, { description: "A feature that is available in the platform." }), U = e.union([e.enum(["VASCO"]), e.string()]).register(e.globalRegistry, { description: "The fulfilment platform used." }), W = e.union([e.enum([
	"MYPARCEL_BE",
	"MYPARCEL_NL",
	"MYPARCEL_IT"
]), e.string()]).register(e.globalRegistry, { description: "The operating platform identifier." }), G = e.string().register(e.globalRegistry, { description: "A shop principal identifier." }), K = e.string().register(e.globalRegistry, { description: "A user principal identifier." }), q = e.union([G, K]), J = e.union([e.enum(["SHOP_DEFAULT"]), e.string()]).register(e.globalRegistry, { description: "The specific role assigned to a shop." }), Y = e.union([e.enum([
	"ADMIN_CS",
	"ADMIN_CS_ADVANCED",
	"ADMIN_FINANCE",
	"ADMIN_IT_SUPPORT",
	"ADMIN_SALES",
	"ADMIN_SUPER",
	"CUSTOMER_ADMIN",
	"CUSTOMER_FINANCIAL",
	"CUSTOMER_FUNCTIONAL_MANAGER",
	"CUSTOMER_MAIN",
	"CUSTOMER_MARKETING",
	"CUSTOMER_SERVICE",
	"CUSTOMER_SUB",
	"CUSTOMER_WAREHOUSE"
]), e.string()]).register(e.globalRegistry, { description: "The specific role assigned to a user." }), X = e.object({
	accountId: e.string().register(e.globalRegistry, { description: "The unique identifier of the account." }),
	platform: W,
	features: e.array(H).optional(),
	fulfilmentPlatforms: e.array(U).optional(),
	impersonator: q.optional()
}), Z = X.and(e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	type: e.union([e.enum(["SHOP"]), e.string()]).register(e.globalRegistry, { description: "The principal type." }),
	role: J,
	shopIds: e.array(e.union([e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." })]))
})), Q = X.and(e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the user." }),
	type: e.union([e.enum(["USER"]), e.string()]).register(e.globalRegistry, { description: "The principal type." }),
	role: Y,
	shopIds: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }))
})), $ = e.union([e.object({ type: e.literal("SHOP") }).and(Z), e.object({ type: e.literal("USER") }).and(Q)]);
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional()
});
var ee = $, te = (e) => (e?.client ?? D).get({
	requestValidator: async (e) => await B.parseAsync(e),
	responseValidator: async (e) => await ee.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/whoami",
	...e
}), ne = "https://iam.api.myparcel.nl", re = "https://iam.api.acceptance.myparcel.nl";
//#endregion
export { F as _, k as a, A as c, L as d, N as f, P as g, R as h, O as i, z as l, M as m, ne as n, B as o, j as p, te as r, V as s, re as t, I as u, D as v, m as y };
